import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export default React.memo(_ => <DataView module={Constants.module.PEDAGOGIE} object={Constants.donnee.eleve}/>)




// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Pedagogie/Eleve/index.js